import ProductoService from 'src/modules/producto/productoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PRODUCTO_VIEW';

const productoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: productoViewActions.FIND_STARTED,
      });

      const record = await ProductoService.find(id);

      dispatch({
        type: productoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: productoViewActions.FIND_ERROR,
      });

      getHistory().push('/producto');
    }
  },
};

export default productoViewActions;
